module.exports = __webpack_public_path__ + "static/media/horoscope-card.cebeda16.jpg";